import Typography from "@mui/material/Typography";
import {alpha, Box, Divider, Grid, IconButton, Link, Stack} from "@mui/material";
import genie_logo from '../../assets/images/logo.svg'
import stb_logo from '../../assets/images/stb-logo.svg'
import cpay_logo from '../../assets/images/cpay-logo.svg'
import visa_logo from '../../assets/images/visa.png'
import mastercard_logo from '../../assets/images/mastercard.png'
import diners_logo from '../../assets/images/diners-club.png'
import useFooterLinks from "./useFooterLinks";
import FooterLinks from "./FooterLinks";
import {useTranslation} from "react-i18next";
import * as React from "react";
import ReactGA from "react-ga4";
import {useTheme} from "@mui/material/styles";
import useSocialMedia from "../../hooks/useSocialMedia";

const Footer = () => {
    const {exploreMore, help, legal} = useFooterLinks()
    const {t} = useTranslation()
    const theme = useTheme()
    const {socialMedia} = useSocialMedia()
    const paymentLogoSx = {
        height: {xs: 20, sm: 22},
        width: "auto",
        objectFit: "contain"
    }

    const handleOnSocialMediaClick = (label: string) => {
        ReactGA.event({
            category: 'Social Links',
            action: 'social_link_click',
            label,
        })
    }

    return (
        <Grid container rowSpacing={{xs: 3, md: 2}} component="footer" sx={{
            backgroundColor: alpha(theme.palette.secondary.main, .6),
            backdropFilter: "blur(5px)",
            mt: {xs: '3em', sm: '2.5em'},
            px: {xs: 2, sm: 3, md: 5},
            py: 2
        }}>
            <Grid item xs={12} md={5}>
                <Stack spacing={1.05} alignItems={{xs: "center", md: "flex-start"}}
                       textAlign={{xs: "center", md: "left"}}>
                    <Box component="img" src={genie_logo} alt="Genie logo" sx={{width: 120, height: "auto"}}/>
                    <Typography variant="body2" sx={{
                        color: alpha(theme.palette.primary.main, .72),
                        maxWidth: {xs: "100%", md: 450}
                    }}>
                        {t('app_description')}
                    </Typography>
                    <Stack direction="row" spacing={2.5} justifyContent={{xs: "center", md: "flex-start"}}>
                        {socialMedia.map((sm) => (
                            <IconButton key={sm.label} size="small" color='primary' sx={{p: 0}}
                                        onClick={() => handleOnSocialMediaClick(sm.label)}
                                        component={Link} href={sm.link} target="_blank" rel="noopener noreferrer">
                                {sm.icon}
                            </IconButton>
                        ))}
                    </Stack>
                </Stack>
            </Grid>

            <Grid item xs={12} md={7} mt={{xs: 0, md: 1}}>
                <Grid container rowSpacing={{xs: 1, md: 0}} columnSpacing={{xs: 1, sm: 1.5, md: 2.5}}
                      justifyContent={{xs: "center", md: "space-evenly"}} alignItems="flex-start">
                    <FooterLinks footerLinks={exploreMore}/>
                    <FooterLinks footerLinks={help}/>
                    <FooterLinks footerLinks={legal}/>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <Divider sx={{borderColor: alpha(theme.palette.primary.main, .14)}}/>
                <Stack direction={{xs: "column", md: "row"}} justifyContent="space-between"
                       alignItems={{xs: "center", md: "center"}} spacing={{xs: 1.15, md: 1.5}}
                       pt={{xs: 1.2, md: 1.4}}>
                    <Typography variant="body1" color="primary" textAlign={{xs: "center", sm: "left"}}>
                        &copy; Genie {new Date().getFullYear()}, {t('all_rights_reserved')}
                    </Typography>
                    <Stack spacing={0.55} alignItems={{xs: "center", md: "flex-end"}}
                           textAlign={{xs: "center", md: "right"}}>
                        <Typography variant="caption" sx={{color: alpha(theme.palette.primary.main, .68)}}>
                            {t('secure_payments')}
                        </Typography>
                        <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap"
                               justifyContent={{xs: "center", md: "flex-end"}}>
                            <Box sx={(theme) => ({
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                px: 1,
                                py: 0.4,
                                borderRadius: 1,
                                backgroundColor: theme.palette.primary.main,
                            })}>
                                <Box component="img" src={cpay_logo} alt="cPay logo"
                                     sx={{height: {xs: 16, sm: 18}, width: "auto"}}/>
                            </Box>
                            <Box component="img" src={stb_logo} alt="STB bank logo" sx={paymentLogoSx}/>
                            <Box component="img" src={visa_logo} alt="Visa logo" sx={paymentLogoSx}/>
                            <Box component="img" src={mastercard_logo} alt="Mastercard logo" sx={paymentLogoSx}/>
                            <Box component="img" src={diners_logo} alt="Diners logo" sx={paymentLogoSx}/>
                        </Stack>
                    </Stack>
                </Stack>
            </Grid>
        </Grid>
    )
}

export default Footer
